<template>
  <div>
    <!-- formulario Template -->
    <v-container>
      <v-form ref="formDatosTemplate" lazy-validation>
        <v-dialog v-model="estadoComp" persistent fullscreen hide-overlay>
          <v-card>
            <v-card-title class="modal_title py-3">
              <span>{{ formTitle }}</span>
              <v-spacer></v-spacer>
              <v-btn fab dark x-small class="btn_style3" @click="$emit('close')">
                <v-icon dark>fa-times</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-4">
              <v-row>
                <v-col cols="12" sm="3" md="2">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field label="Nombre de la plantilla" v-model="dataContenido.nombre_template" single-line
                        hide-details :rules="[rul.required]"></v-text-field>
                    </v-col>

                    <v-col cols="12">

                      <v-select label="Nivel" v-model="dataContenido.id_nivel" small :items="listNivel" item-value="id"
                        item-text="desc_nivel" @change="EventNivel()">
                      </v-select>

                      <v-select label="Área" v-model="dataContenido.id_area" :items="listArea" item-value="id"
                        item-text="desc_area" :rules="[rul.required]">
                      </v-select>
                    </v-col>

                    <v-divider></v-divider>
                    <v-col cols="12">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12">
                      <v-btn class="btn_green" small dark @click="
                        mostraPlantillaComponent = !mostraPlantillaComponent
                        ">
                        <v-icon>mdi-magnify</v-icon>
                        Mis imágenes
                      </v-btn>
                    </v-col>

                    <template v-if="mostraPlantillaComponent">
                      <div class="container">
                        <v-row wrap style="max-height: 40vh" class="overflow-y-auto">
                          <v-col cols="12" md="6" v-for="(item, index) of listResourseTemplate" :key="index">

                            <v-card v-if="item.id_tipo_recurso.trim() == 'imgp'" class="cardMiniatura">
                              <i @click="DeleteFile(item)" class="fas fa-times-circle fa-1x iconoEliminarBadge" style="
                                  color: #c10606;
                                  cursor: pointer;
                                  display: grid;
                                  justify-content: end;
                                "></i>
                              <v-img :src="URL_SPACE + item.file_link" :lazy-src="URL_SPACE + item.file_link"
                                @click="LoadImageTemplate(item.file_link)" class="white--text align-end imagen">
                                <template v-slot:placeholder>
                                  <div class="d-flex align-center justify-center fill-height">
                                    <v-progress-circular color="grey-lighten-4" indeterminate></v-progress-circular>
                                  </div>
                                </template>
                              </v-img>

                              <div class="contMiniatura text-center">
                                <span class="font-black" style="font-size: 10px">{{ item.file_desc }}</span>
                              </div>
                            </v-card>

                          </v-col>
                        </v-row>
                      </div>
                    </template>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="9" md="10">
                  <v-row class="py-2">
                    <v-col cols="12">
                      <v-toolbar dense small>
                        <v-overflow-btn v-if="objectSelected != null &&
                          objectSelected.data.type == 'texto'
                        " :items="textConfig.fonts" item-value="value" item-text="name" small dense label="Fuente"
                          v-model="fontFamily" hide-details class="pa-0" @change="RenderFontFamily()">
                        </v-overflow-btn>

                        <template v-if="objectSelected != null &&
                          objectSelected.data.type == 'texto'
                        ">
                          <v-divider vertical></v-divider>
                          <v-responsive class="mx-2 pt-5" max-width="50">
                            <v-text-field type="number" v-if="objectSelected &&
                              objectSelected.data.type == 'texto'
                            " min="5" max="500"
                              oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                              placeholder="Tamaño de Fuente" v-model.number="fontSize"
                              @input="RenderFontSize()"></v-text-field>
                          </v-responsive>

                          <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="mx-2" small dense text :style="swatchStyle"
                                id="menu-ct-activator-t" v-if="objectSelected &&
                                  objectSelected.data.type == 'texto'
                                ">
                                <v-img src="@/assets/iconos/font.jpg"></v-img>
                              </v-btn>
                            </template>
                            <span>Color de la fuente</span>
                          </v-tooltip>

                          <v-menu activator="#menu-ct-activator-t" top nudge-bottom="105" nudge-left="16"
                            :close-on-content-click="false">
                            <v-card>
                              <v-card-text class="pa-0">
                                <v-color-picker v-model="objectSelected.data.color" mode="hexa" @input="RenderFill()" />
                              </v-card-text>
                            </v-card>
                          </v-menu>

                          <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" small id="menu-cbt-activator-t" v-if="objectSelected &&
                                objectSelected.data.type == 'texto'
                              ">
                                <v-icon small>fas fa-fill</v-icon>
                              </v-btn>
                            </template>
                            <span>Color de fondo de la fuente</span>
                          </v-tooltip>

                          <v-menu activator="#menu-cbt-activator-t" top nudge-bottom="105" nudge-left="16"
                            :close-on-content-click="false">
                            <v-card>
                              <v-card-text class="pa-0">
                                <v-color-picker v-model="objectSelected.data.backgroundColor" mode="hexa" show-swatches
                                  :swatches="swatches" @input="RenderBackGroundColorText()" />
                              </v-card-text>
                            </v-card>
                          </v-menu>

                          <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" @click="changeFontWeight()" small dense text cols="2" :color="objectSelected.fontWeight == 'normal'
                                ? 'default'
                                : 'primary'
                                ">
                                <v-icon>fa-solid fa-bold</v-icon>
                              </v-btn>
                            </template>
                            <span>Negrita</span>
                          </v-tooltip>

                          <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" @click="changeFontStyle()" small dense text :color="objectSelected.fontStyle == 'normal'
                                ? 'default'
                                : 'primary'
                                ">
                                <v-icon>fa-solid fa-italic</v-icon>
                              </v-btn>
                            </template>
                            <span>Cursiva</span>
                          </v-tooltip>

                          <!--        
                                                <v-btn small dense text>
                                                    <v-icon>fa-solid fa-underline</v-icon>
                                                </v-btn> 
                                                -->

                          <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" @click="changeFontVariant()" small dense text :color="objectSelected.fontVariant == 'lowercase'
                                ? 'default'
                                : 'primary'
                                ">
                                <v-icon>fa-solid fa-font</v-icon>
                              </v-btn>
                            </template>
                            <span>Alternar mayúsculas</span>
                          </v-tooltip>

                          <v-btn-toggle small dense v-model="objectSelected.textAlign" mandatory @change="Render()">

                            <v-tooltip bottom color="#1b1b1b">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" value="left">
                                  <v-icon>fa-solid fa-align-left</v-icon>
                                </v-btn>
                              </template>
                              <span>Alinear a la izquierda</span>
                            </v-tooltip>

                            <v-tooltip bottom color="#1b1b1b">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" value="center">
                                  <v-icon>fa-solid fa-align-center</v-icon>
                                </v-btn>
                              </template>
                              <span>Centrar</span>
                            </v-tooltip>

                            <v-tooltip bottom color="#1b1b1b">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" value="right">
                                  <v-icon>fa-solid fa-align-right</v-icon>
                                </v-btn>
                              </template>
                              <span>Alinear a la derecha</span>
                            </v-tooltip>

                            <v-tooltip bottom color="#1b1b1b">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" value="justify-left">
                                  <v-icon>fa-solid fa-align-justify</v-icon>
                                </v-btn>
                              </template>
                              <span>Justificar</span>
                            </v-tooltip>
                          </v-btn-toggle>
                          <v-spacer></v-spacer>
                        </template>

                        <v-tooltip bottom color="#1b1b1b">
                          <template v-slot:activator="{ on }">
                            <v-btn small v-on="on" class="btn_palette mr-2" id="menu-fondo-a">
                              <v-icon small>fas fa-palette</v-icon>
                            </v-btn>
                          </template>
                          <span>Color de fondo</span>
                        </v-tooltip>

                        <v-menu activator="#menu-fondo-a" :close-on-content-click="false">
                          <v-card>
                            <v-card-text class="pa-0">
                              <v-color-picker v-model="color_fondo" mode="hexa" show-swatches :swatches="swatches">
                              </v-color-picker>
                            </v-card-text>
                          </v-card>
                        </v-menu>

                        <v-btn class="btn_block_style2 mr-2" small dark @click="AddTexto()"> <v-icon
                            left>fa-plus</v-icon>
                          AGREGAR TEXTO</v-btn>

                        <v-btn class="btn_green mr-2" small dark warning @click="openFileInput">
                          <v-icon>mdi-upload</v-icon>
                          SUBIR IMAGEN
                        </v-btn>
                        <v-file-input ref="ImgPlantilla" @change="OnArchivoChange" style="display: none"
                          accept=".png, .jpg, .jpeg, .gif" multiple>
                        </v-file-input>
                        <v-btn v-if="objectSelected != null" class="btn_style3" dark small @click="BorrarObject()">
                          <v-icon left>fa-trash-alt</v-icon>
                          Borrar Elemento</v-btn>
                      </v-toolbar>
                    </v-col>

                    <v-col cols="12" ref="canvasKWSTemplate" class="canvasKWSParent justify-center align-center py-1">
                      <canvas id="canvasT" class="canvasKWST"></canvas>
                    </v-col>

                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>

              <v-spacer></v-spacer>

              <v-btn class="btn_block_style2" dark v-if="this.parametros.evento == 'editar'" @click="SaveItem()"
                :loading="guardando"> <v-icon left>fas fa-save</v-icon> Guardar Cambios</v-btn>
              <v-btn class="btn_block_style2" dark v-if="this.parametros.evento == 'agregar'" @click="SaveItem()"
                :loading="guardando"> <v-icon left>fas fa-save</v-icon> Guardar</v-btn>
              <v-btn class="btn_style3" dark @click="Close()">Cancelar</v-btn>

              <input dark small type="file" @change="CargarScene($event)" hidden="false" ref="mySceneInput" />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
      <!-- fin modal -->
    </v-container>
  </div>
</template>

<script>
import axios, { BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { mapActions, mapGetters, mapMutations } from "vuex";

import { fabric } from "fabric";

export default {
  name: "crearGCPlantillaManager",
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  data() {
    return {
      datoLogin: sessionStorage,
      listResourseTemplate: [],
      mostraPlantillaComponent: false,
      filtro: {},
      URL_SPACE: BUCKET_ORIGIN_SPACE,
      evento: null,
      test: false,
      canvas: null,
      widthScene: null,
      heightScene: null,
      objectSelected: null,
      timecomputed: new Date().getTime(),
      dataContenido: {},
      color_fondo: "#FFFFFF",
      swatches: [
        ["transparent", "#AA0000", "#550000"],
        ["#FFFF00", "#AAAA00", "#555500"],
        ["#00FF00", "#00AA00", "#005500"],
        ["#00FFFF", "#00AAAA", "#005555"],
        ["#0000FF", "#0000AA", "#000055"],
      ],
      listNivel: [],
      listArea: [],
      paramComponente: { id_submodulo: 22, id_modulo: 4 },
      textConfig: {
        fonts: [{
          name: "Default",
          value: "Times,serif",
        },
        {
          name: "Arial",
          value: "Arial,Helvetica,sans-serif",
        },
        {
          name: "Comic Sans MS",
          value: "'Comic Sans MS',cursive",
        },
        {
          name: "Courier New",
          value: "'Courier New',Courier,monospace",
        },
        {
          name: "Georgia",
          value: "Georgia,serif",
        },
        {
          name: "Lucida Sans Unicode",
          value: "'Lucida Sans Unicode','Lucida Grande',sans-serif",
        },
        {
          name: "Tahoma",
          value: "Tahoma,Geneva,sans-serif",
        },
        {
          name: "Times New Roman",
          value: "'Times New Roman', Times, serif",
        },
        {
          name: "Trebuchet MS",
          value: "'Trebuchet MS',Helvetica,sans-serif",
        },
        {
          name: "Trebuchet MS",
          value: "'Trebuchet MS',Helvetica,sans-serif",
        },
        {
          name: "Verdana",
          value: "Verdana,Geneva,sans-serif",
        },
        ],
      },
      fontSize: 25,
      // fontFamily: 'Times,serif',
      fontFamily: "'Comic Sans MS',cursive",
      rul: {
        required: (value) => !!value || "Campo requerido",
        inputReq: (value) => !!value || "Campo requerido",
        selectReq: (value) =>
          !!value || "Debe seleccionar un campo de la lista",
        selectIDReq: (value) =>
          value != -1 || "Debe seleccionar un campo de la lista",
        email: (value) =>
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
          "El correo Electrónico es incorrecto",
        min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
        min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
        min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
        max03: (v) => (`${v}` || "").length <= 3 || "Máximo 3 caracteres",
        max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
        max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
        max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
        max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
        max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
        max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
        max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
        max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
        max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
        max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",
      },
      guardando: false,
    };
  },
  mounted() {
    this.loadMain();
  },
  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    formTitle() {
      return this.parametros.evento === "agregar" ?
        "Crear plantilla" :
        "Editar plantilla";
    },
    swatchStyle() {
      return {
        color: this.objectSelected.fill,
        cursor: "pointer",
        borderRadius: "4px",
      };
    },
    cacheDinamica() {
      const randomValue = Math.random().toString(36).substring(2, 15);
      const tm = this.timecomputed;
      return `?nocache=${tm}${randomValue}`;
    },
  },
  watch: {
    mostraPlantillaComponent(flag) {
      if (flag) {
        this.GetResourceTemplate();
      }
    },
    estadoComp() {
      if (this.estadoComp) {
        this.loadMain();
      } else {
        //this.parametros = {}
        this.LimpiarForm();
      }
    },

    color_fondo(newValor) {
      this.EventBackground(newValor);
    },
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    /**
     ___________________________________________
    |          MÉTODO CARGAR INICIAL          */
    loadMain() {
      this.LimpiarForm();
      this.timecomputed = new Date().getTime();
      this.dataContenido.id_nivel = this.parametros.id_nivel;
      this.getNivel();
      this.getAreas();
      // this.$refs.formDatos.resetValidation()
      if (this.parametros.evento == "editar") {
        this.editItem(this.parametros.item);
      } else {

        this.$nextTick(() => {
          this.LoadFabric();
        });

      }
      // Eliminar elementos con suprimir
      document.onkeydown = (e) => {
        if (this.objectSelected && e.which == 46) {
          if (this.objectSelected.data.type == "texto") {
            if (!this.objectSelected.isEditing) this.BorrarObject();
          } else {
            this.BorrarObject();
          }
        }
      };
    },
    /**
     _______________________________________________
    |          MÉTODO ABRIR ARCHIVO FILE          */
    openFileInput() {
      const actualInput = this.$refs.ImgPlantilla.$el.querySelector('input[type="file"]');
      if (actualInput) {
        actualInput.click();
      }
    },
    /**
     _________________________________________________________
    |          MÉTODO CAMBIAR SELECCION DE ARCHIVO          */
    async OnArchivoChange(e) {
      if (e !== undefined) {
        this.mostraPlantillaComponent = true;
        this.saveArchivo(e);
      }
    },
    /**
     _________________________________________
    |          MÉTODO SUBIR IMAGEN          */
    async saveArchivo(templatesFiles) {
      let formData = new FormData();
      formData.append("id_pais", this.parametros.id_pais);
      formData.append("id_clase", 0);
      formData.append("id_tema", 0);
      formData.append("id_nivel", 0);
      formData.append("id_area", 0);
      formData.append("id_tipo_recurso", "imgp");
      formData.append("id_acceso", 1);
      formData.append("id_usuario", this.datoLogin.id);
      for (let index = 0; index < templatesFiles.length; index++) {
        const archivo = templatesFiles[index];
        formData.append("archivos", archivo);
      }
      try {
        let response = {};
        // if (this.parametros.evento == "agregar") {
        response = await axios.post(
          "/manager/fileS3/gestorContenido",
          formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
        );
        // }
        // if (this.parametros.evento == "editar") {
        //   response = await axios.put(
        //     `/manager/fileS3/gestorContenido/${this.data.id}`, { datos: this.data }
        //   );
        // }
        this.GetResourceTemplate();
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    /**
     ______________________________________________
    |          MÉTODO OBTENER PLANTILLAS         */
    async GetResourceTemplate() {
      try {
        let response = await axios.post(
          `/manager/fileS3/gestorContenidoListTemplates/`, {
          filtro: {
            id_pais: 145,
            id_acceso: 1,
            id_tipo_recurso: "imgp",
            id_us_ing: 17,
          },
        }
        );

        this.listResourseTemplate = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     __________________________________________
    |          MÉTODO CARGAR FABRIC          */
    LoadFabric() {
      if (this.canvas) {
        this.canvas.dispose();
      }

      this.canvas = new fabric.Canvas("canvasT", {
        selection: false,
        renderOnAddRemove: true,
        enableWebGL: true,
      });
      fabric.Image.prototype.quality = "high";

      // renderer
      this.onWindowResize();
      window.addEventListener("resize", this.onWindowResize);


      this.canvas.on("selection:created", (obj) => {
        this.objectSelected = obj.selected[0];
        if (this.objectSelected.data.type == "texto")
          this.fontSize = this.objectSelected.fontSize;
      });

      this.canvas.on("selection:updated", (obj) => {
        this.objectSelected = obj.selected[0];
        if (this.objectSelected.data.type == "texto")
          this.fontSize = this.objectSelected.fontSize;
      });

      this.canvas.on("selection:cleared", () => {
        this.objectSelected = null;
      });

      // Aplicar la caché a todos los objetos en el lienzo
      this.canvas.forEachObject((object) => {
        object.set({ cache: true });
      });

      fabric.util.requestAnimFrame(this.Render);
    },
    /**
     __________________________________________________
    |          MÉTODO CREAR TEXTO DE FABRIC          */
    CreateTextFabric(texto) {
      let text = new fabric.Textbox(`${texto}`, {
        width: 250,
        fill: "#000000",
        fontFamily: this.fontFamily,
        fontSize: this.fontSize || 25,
        textAlign: "center",
        fontWeight: "normal",
        fontVariant: "lowercase",
        fontStyle: "normal",
        originX: "center",
        originY: "center",
        backgroundColor: "#FFFFFF00",
      });
      text.data = {
        type: "texto",
        color: "#000000",
        backgroundColor: "#FFFFFF00",
      };
      this.setStyleCorner(text);
      text.hiddenTextareaContainer = this.canvas.lowerCanvasEl.parentNode;
      this.canvas.add(text);
      this.canvas.centerObject(text);
      this.canvas.setActiveObject(text);
      text.selectAll();
      return text;
    },
    /**
     __________________________________________
    |          MÉTODO CARGAR IMAGEN          */
    async LoadImageTemplate(fileLink) {
      await this.AddImageTemplate(`${fileLink}`);
    },
    /**
     __________________________________________
    |          MÉTODO AÑADIR IMAGEN          */
    async AddImageTemplate(fileLink) {
      return new Promise((resolve, reject) => {
        let image = document.createElement("img");
        image.crossOrigin = "anonymous"; // Establecer esto antes de asignar el 'src'
        image.src = this.URL_SPACE + fileLink + this.cacheDinamica;
        image.onload = () => {
          let imgInstance = new fabric.Image(image, {
            crossOrigin: "anonymous",
          });
          imgInstance.data = { type: "imagen", fileLink: fileLink };
          this.setStyleCorner(imgInstance);
          if (this.heightScene < image.height)
            imgInstance.scaleToHeight(this.heightScene);

          this.canvas.add(imgInstance);
          this.canvas.centerObject(imgInstance);
          this.Render();
          resolve(image);
        };
        image.onerror = (error) => {
          console.error("Error al cargar la imagen:", error);
          reject(error);
        };
        image.onerror = reject;
      });
    },
    /**
     ______________________________________________________
    |          MÉTODO RENDERIZAR ESTILOS FABRIC          */
    RenderFill() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        this.objectSelected.set("fill", this.objectSelected.data.color);
      } else {
        this.objectSelected.setSelectionStyles({ fill: this.objectSelected.data.color },
          this.objectSelected.selectionStart,
          this.objectSelected.selectionEnd
        );
      }
      this.Render();
    },
    /**
     _______________________________________________________________
    |          MÉTODO RENDERIZAR ESTILOS Y TEXTOS FABRIC          */
    RenderBackGroundColorText() {
      if (
        this.objectSelected.data.backgroundColor.substring(0, 7) != "#FFFFFF" &&
        this.objectSelected.data.backgroundColor.substring(7, 9) == "00"
      ) {
        this.objectSelected.data.backgroundColor = `${this.objectSelected.data.backgroundColor.substring(
          0,
          7
        )}FF`;
        this.objectSelected.set(
          "backgroundColor",
          `${this.objectSelected.data.backgroundColor.substring(0, 7)}FF`
        );
      } else {
        this.objectSelected.set(
          "backgroundColor",
          this.objectSelected.data.backgroundColor.substring(0, 9)
        );
      }
      this.Render();
    },
    /**
     _______________________________________________
    |          MÉTODO RENDERIZAR FUENTES          */
    RenderFontSize() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        this.objectSelected.set("fontSize", this.fontSize);
      } else {
        this.objectSelected.setSelectionStyles({ fontSize: this.fontSize },
          this.objectSelected.selectionStart,
          this.objectSelected.selectionEnd
        );
      }
      this.Render();
    },
    /**
     _____________________________________
    |          MÉTODO FAMILY FONT       */
    RenderFontFamily() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        this.objectSelected.set("fontFamily", this.fontFamily);
      } else {
        this.objectSelected.setSelectionStyles({ fontFamily: this.fontFamily },
          this.objectSelected.selectionStart,
          this.objectSelected.selectionEnd
        );
      }
      this.Render();
    },
    /**
     _______________________________________________________
    |          MÉTODO ACTUALIZAR FABRIC - CANVAS          */
    Render() {
      this.canvas.renderAll();
      fabric.util.requestAnimFrame(this.Render);
    },
    /**
     _________________________________________________
    |          MÉTODO BORRAR OBJETO FABRIC          */
    BorrarObject() {
      if (this.objectSelected) {
        this.canvas.remove(this.objectSelected);
        this.objectSelected = null;
      }
    },
    /**
     __________________________________________
    |          MÉTODO LOGICA EDITAR          */
    async editItem(item) {
      this.dataContenido = item;
      this.color_fondo = item.background;
      this.CargarScene(item);
    },
    /**
     _______________________________________________
    |          MÉTODO AÑADIR TEXTO LIENZO         */
    AddTexto() {
      this.CreateTextFabric("Agregar Texto");
      this.Render();
    },
    /**
     ________________________________________________
    |          MÉTODO AÑADIR FONDO LIENZO          */
    EventBackground(valor) {
      if (this.canvas) {
        this.dataContenido.background = valor;
        let color = `${valor.substring(0, 9)}`;
        this.canvas.backgroundColor = color;
        this.Render();
      } else {
        console.error("Canvas no está inicializado");
      }
    },
    /**
     _________________________________________________
    |          MÉTODO ELIMINAR FILE IMAGEN          */
    async DeleteFile(item) {
      try {
        await axios.delete(`/manager/fileS3/gestorContenido/${item.id}`);
        this.GetResourceTemplate();
        // this.listTemplate = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     _______________________________________________
    |          MÉTODO LIMPIAR FORMULARIO          */
    LimpiarForm() {
      if (this.canvas) {
        this.canvas.getObjects().forEach((obj) => {
          this.canvas.remove(obj);
        });
      }

      this.guardando = false;
      this.objectSelected = null;
      this.dataContenido = {
        id_area: this.parametros.item ? this.parametros.item.id_area : 23,
        background: "#FFFFFF",
        canvas: "",
        miniatura: "",
        nombre_template: "",
        id_us_ing: this.datoLogin.id,
        fec_us_ing: null,
        id_us_mod: null,
        fec_us_mod: null,
        estado_template: true,
      };
      this.listResourseTemplate = [];
      this.mostraPlantillaComponent = false;
      this.clearCanvas()
    },

    clearCanvas() {
      if (this.canvas) {
        this.canvas.clear();
        this.Render();
      } else {
        console.error("El canvas no está inicializado");
      }
    },
    /**
     ____________________________________________________
    |          MÉTODO REAJUSTAR LIENZO CANVAS          */
    onWindowResize() {
      if (this.$refs.canvasKWSTemplate) {
        this.widthScene = this.$refs.canvasKWSTemplate.clientWidth * 0.8;
        this.heightScene = (this.widthScene * 55) / 100;
        if (this.canvas) {
          this.canvas.setDimensions({ width: this.widthScene, height: this.heightScene });
          this.canvas.renderAll(); // Asegura que se renderice de nuevo
          this.canvas.calcOffset();
        }
      }
    },
    /**
     _______________________________________________________
    |          MÉTODO CONVERSOR DE CANVAS A FILE          */
    async canvastoFile() {
      let dataurl = await this.canvas.toDataURL("image/png");
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], `${this.dataContenido.nombre_template}.png`, {
        type: mime,
      });
    },
    /**
     ______________________________________________
    |          MÉTODO GUARDAR PLANTILLA          */
    async SaveItem() {
      if (!this.$refs.formDatosTemplate.validate()) {
        this.setEnviarMens({
          tipo: `W`,
          mensaje: `Debe completar todos los campos requeridos`,
          tiempo: 6000,
        });
        return false;
      }
      let canvasJson = await this.canvas.toJSON(["data", "fontVariant"]);

      let objects = canvasJson.objects;
      for (let index = 0; index < objects.length; index++) {
        switch (objects[index].data.type) {
          case "imagen":
            canvasJson.objects[index].src = objects[index].data.fileLink;
            break;
        }
      }
      try {
        this.guardando = true;
        let res = "";

        let formData = new FormData();
        canvasJson["widthScene"] = this.widthScene;
        canvasJson["heightScene"] = this.heightScene;
        formData.append("id_usuario", this.datoLogin.id);
        formData.append("id_colegio", this.datoLogin.id_colegio);
        formData.append("miniatura", await this.canvastoFile());
        formData.append("canvas", JSON.stringify(canvasJson));

        for (let key in this.dataContenido) {
          if (key != "canvas" && key != "miniatura")
            formData.append(key, this.dataContenido[key]);
        }

        if (this.parametros.evento == "agregar") {
          res = await axios.post("/manager/contenido/templateDiap/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        }

        if (this.parametros.evento == "editar") {
          res = await axios.put(
            `/manager/contenido/templateDiap/${this.parametros.item.id}`,
            formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
          );
        }

        if (res.data.messageT == "S") {
          this.guardando = false;
          this.LimpiarForm();
          this.$emit("close");
          this.$emit("reloadComp", 'template');
        }

        this.setEnviarMens({
          tipo: `${res.data.messageT}`,
          mensaje: `${res.data.message}`,
          tiempo: 6000,
        });
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      } finally {
        this.guardando = false;
      }
    },
    /**
     __________________________________________________
    |          MÉTODO ESTILOS BORDES FABRIC          */
    setStyleCorner(objeto) {
      if (objeto.data.type == "texto")
        objeto.setControlsVisibility({
          tl: false,
          mt: false,
          tr: false,
          bl: false,
          mb: false,
          br: false,
        });
      (objeto.cornerColor = "white"),
        (objeto.cornerStrokeColor = "black"),
        (objeto.cornerStyle = "circle");
    },
    /**
     ______________________________________________
    |          MÉTODO ACTUALIZAR VIDEOS          */
    ActualizarElementoVideo(obj) {
      axios({
        url: `${obj.data.fileLink}`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        if (response.status == 200) {
          const src = URL.createObjectURL(new Blob([response.data]));
          let videoElem = this.SetUpVideo(src);
          // let videoElem = document.getElementById('video1');
          videoElem.onloadeddata = () => {
            videoElem.width = videoElem.videoWidth;
            videoElem.height = videoElem.videoHeight;
            obj.setElement(videoElem);
            this.Render();
          };
        }
      });
    },
    /**
     ______________________________________________
    |          MÉTODO ACTUALIZAR AUDIOS          */
    ActualizarElementoAudio(obj) {
      axios({
        url: `${obj.data.fileLink}`,
        method: "GET",
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "audio/wav",
        },
      }).then((response) => {
        if (response.status == 200) {
          const src = URL.createObjectURL(
            new Blob([response.data], { type: "audio/wav" })
          );
          let audioElem = this.SetUpAudio(src);
          obj.data.element = audioElem;
          this.Render();
        }
      });
    },
    /**
     ___________________________________________________________
    |          MÉTODO CARGAR ESCENA EN LIENZO CANBAS          */
    async CargarScene(data) {
      await this.cargarPlantilla(data.canvas);
    },
    /**
      ____________________________________________________________
     |          MÉTODO CARGAR Y RENDERIZAR DIAPOSITIVA          */
    async cargarPlantilla(canvas) {
      this.cargando = true;
      if (!this.canvas) this.LoadFabric();
      if (canvas) {

        if (canvas.objects != undefined) {

          canvas.objects = canvas.objects.map((item) => {
            switch (item.data.type) {
              case "imagen":
                if (!item.src.includes(this.URL_SPACE)) {
                  item.data.fileLink = this.URL_SPACE + item.src + this.cacheDinamica;
                  return { ...item, src: this.URL_SPACE + item.src + this.cacheDinamica };
                } else {
                  item.data.fileLink = item.src;
                  return { ...item, src: item.src };
                }

              default:
                return { ...item };
            }
          });
        }

        this.canvas.loadFromJSON(canvas, () => {
          this.canvas.forEachObject((object) => {
            object.set({ cache: true });
          });

          this.canvas
            .getObjects()
            .filter((obj) => obj.data.type == "texto")
            .forEach((obj) => {
              obj.hiddenTextareaContainer = this.canvas.lowerCanvasEl.parentNode;
              if (!obj.data.backgroundColor) {
                obj.set("backgroundColor", `#FFFFFF00`);
                obj.data.backgroundColor = `#FFFFFF00`;
              }
            });

          let objects = this.canvas.getObjects();

          let canvasJ =
            typeof canvas === "object" ? this.dataContenido.canvas : JSON.parse(this.dataContenido.canvas);
          if (
            canvasJ.hasOwnProperty("widthScene") &&
            canvasJ["widthScene"] != this.widthScene
          ) {
            let scaleMultiplier = this.widthScene / canvasJ["widthScene"];
            for (var i in objects) {
              objects[i].scaleX = objects[i].scaleX * scaleMultiplier;
              objects[i].scaleY = objects[i].scaleY * scaleMultiplier;
              objects[i].left = objects[i].left * scaleMultiplier;
              objects[i].top = objects[i].top * scaleMultiplier;
              objects[i].setCoords();
            }
          }
          for (let index = 0; index < objects.length; index++) {
            this.setStyleCorner(objects[index]);
          }

          this.Render();
        });
      } else {
        console.log('aun no lo se');
      }
    },
    /**
     _______________________________________________________________
    |          MÉTODO CAMBIAR FUENTES Y GROSOR DE FUENTE          */
    changeFontWeight() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        if (this.objectSelected.fontWeight == "bold") {
          this.objectSelected.fontWeight = "normal";
        } else {
          this.objectSelected.fontWeight = "bold";
        }
      } else {
        if (
          this.objectSelected
            .getSelectionStyles()
            .find((charOption) => charOption.fontWeight == "bold")
        ) {
          this.objectSelected.setSelectionStyles({ fontWeight: "normal" },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        } else {
          this.objectSelected.setSelectionStyles({ fontWeight: "bold" },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        }
      }
      this.Render();
    },
    /**
     _____________________________________________________
    |          MÉTODO CAMBIAR ESTILO DE FUENTE          */
    changeFontStyle() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        if (this.objectSelected.fontStyle == "italic") {
          this.objectSelected.fontStyle = "normal";
        } else {
          this.objectSelected.fontStyle = "italic";
        }
      } else {
        if (
          this.objectSelected
            .getSelectionStyles()
            .find((charOption) => charOption.fontStyle == "italic")
        ) {
          this.objectSelected.setSelectionStyles({ fontStyle: "normal" },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        } else {
          this.objectSelected.setSelectionStyles({ fontStyle: "italic" },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        }
      }
      this.Render();
    },
    /**
     _____________________________________________________
    |          MÉTODO CAMBIAR ESTILO DE FUENTE          */
    changeFontVariant() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        if (this.objectSelected.fontVariant == "lowercase") {
          this.objectSelected.text = this.objectSelected.text.toUpperCase();
          this.objectSelected.fontVariant = "uppercase";
        } else {
          this.objectSelected.text = this.objectSelected.text.toLowerCase();
          this.objectSelected.fontVariant = "lowercase";
        }
      } else {
        let selectedText = this.objectSelected.getSelectedText();
        if (selectedText) {
          let styles = this.objectSelected.getSelectionStyles();
          if (selectedText == selectedText.toUpperCase()) {
            this.objectSelected.insertChars(
              selectedText.toLowerCase(),
              styles.map((style) => {
                style.fontVariant = "lowercase";
                return style;
              }),
              this.objectSelected.selectionStart,
              this.objectSelected.selectionEnd
            );
          } else {
            this.objectSelected.insertChars(
              selectedText.toUpperCase(),
              styles.map((style) => {
                style.fontVariant = "lowercase";
                return style;
              }),
              this.objectSelected.selectionStart,
              this.objectSelected.selectionEnd
            );
          }
        }
      }
      this.Render();
    },
    /**
     __________________________________________
    |          MÉTODO OBTENER AREAS          */
    async getAreas() {
      try {
        const response = await axios.post("/manager/areaCkOne/pais/", {
          id_nivel: this.dataContenido.id_nivel,
          id_pais: this.datoLogin.id_pais,
        });
        this.listArea = response.data;

        if (this.listArea == "") {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No existen áreas creadas para éste Nivel",
            tiempo: null,
          });
        }

        if (
          !this.listArea.find((area) => this.dataContenido.id_area == area.id)
        )
          this.dataContenido.id_area = null;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
    /**
     ______________________________________________
    |          MÉTODO CERRAR COMPONENTE          */
    Close() {
      this.$emit("close");
    },
    /**
     __________________________________________
    |          MÉTODO OBTENER NIVEL          */
    async getNivel() {
      try {
        let response = await axios.get(
          `/manager/nivelCkOne/pais/${this.parametros.id_pais}`
        );
        this.listNivel = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     _____________________________________________________
    |          MÉTODO CAMBIAR NIVEL - ONCHANGE          */
    async EventNivel() {
      this.getAreas();
    },
  },
};
</script>
<!-- ESPECIFICO -->
<style scoped>
.canvasKWSParent {
  display: flex;
  align-items: center;
  justify-content: center;
}

.canvasKWST {
  box-shadow: 1px 1px 1px 1px #888888;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5em;
}
</style>
